module.exports = __webpack_public_path__ + "templates/single-notification.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/notifications/templates/single-notification.html
// module id = Oqu7
// module chunks = 1